<section class="meetings-panel" role="tabpanel">
  @if (carregando()) {
    <div class="meetings-panel__state">
      <app-cog-loading-spinner [size]="64" />
      <span>Carregando as reuniões...</span>
    </div>
  } @else if (erro()) {
    <div class="meetings-panel__state meetings-panel__state--error" role="alert">
      <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
      <strong>{{ erro() }}</strong>
      <app-button
        [label]="'Tentar de novo'"
        [theme]="'outline-grey'"
        [type]="'button'"
        (sendButtonClick)="carregar()" />
    </div>
  } @else if (!ligacoes().length) {
    <div class="meetings-panel__state">
      <i class="pi pi-video" aria-hidden="true"></i>
      <strong>Nenhuma reunião vinculada a este deal ainda.</strong>
      <span>
        As reuniões do Teams dos usuários Legatus com os participantes da empresa aparecem aqui
        automaticamente, com gravação e transcrição.
      </span>
    </div>
  } @else {
    <ol class="meetings-panel__list">
      @for (meeting of ligacoes(); track meeting.id) {
        <li class="meeting-card">
          <header class="meeting-card__head">
            <span class="meeting-card__icon" aria-hidden="true"><i class="pi pi-video"></i></span>
            <div class="meeting-card__titles">
              <h3 class="meeting-card__title">{{ meeting.title }}</h3>
              <p class="meeting-card__meta">
                {{ meeting.scheduledStartAt | vaultDateTime }}
                · {{ duracao(meeting.durationSeconds) }}
                @if (meeting.organizerName || meeting.organizerEmail) {
                  · organizada por {{ meeting.organizerName || meeting.organizerEmail }}
                }
              </p>
            </div>
            <app-meeting-status-tag [status]="meeting.status" />
          </header>

          <app-meeting-participants [participants]="meeting.participants" />

          <footer class="meeting-card__actions">
            <!-- Tela de detalhe (card 3162): vídeo, download e transcrição ligada ao vídeo. -->
            <app-button
              [label]="'Ver detalhes'"
              [icon]="'pi pi-eye'"
              [size]="'small'"
              [theme]="'outline-grey'"
              [type]="'button'"
              (sendButtonClick)="abrirDetalhe(meeting)" />
            @if (meeting.hasRecording) {
              <app-button
                [label]="'Assistir gravação'"
                [icon]="'pi pi-play'"
                [size]="'small'"
                [type]="'button'"
                (sendButtonClick)="assistir(meeting)" />
            }
            @if (meeting.hasTranscript) {
              <app-button
                [label]="'Ver transcrição'"
                [icon]="'pi pi-file'"
                [size]="'small'"
                [theme]="'outline-grey'"
                [type]="'button'"
                (sendButtonClick)="verTranscricao(meeting)" />
            }
            @if (!meeting.hasRecording && !meeting.hasTranscript) {
              <span class="meeting-card__none">Sem gravação nem transcrição disponíveis.</span>
            }
            @if (podeDesvincular()) {
              <app-button
                class="meeting-card__unlink"
                [label]="'Desvincular'"
                [icon]="'pi pi-link'"
                [size]="'small'"
                [theme]="'outline-grey'"
                [type]="'button'"
                [isLoading]="desvinculando() === meeting.id"
                [disabled]="!!desvinculando()"
                (sendButtonClick)="desvincular(meeting)" />
            }
          </footer>
        </li>
      }
    </ol>
  }
</section>

<app-modal-meeting-recording #modalGravacao />
<app-modal-meeting-transcript #modalTranscricao />
